export default {
    "goal": "Mål.",
    "goal_team_only": "{{score}}Mål {{scoring_team}}!",
    "goal_team_player": "{{score}}Mål {{scoring_team}}! Målskytt {{scoring_player}}.",
    "own_goal_team_player": "{{score}}Mål {{scoring_team}}. Självmål av {{scoring_player}}.",

    "yellow_card": "Gult kort.",
    "yellow_card_team_only": "Gult kort {{team}}.",
    "yellow_card_team_player": "Gult kort {{team}}: {{player}}.",

    "red_card": "Rött kort.",
    "red_card_team_only": "Rött kort {{team}}.",
    "red_card_team_player": "Rött kort {{team}}: {{player}}.",

    "penalty": "Straffspark.",
    "penalty_by_team": "Straffspark, {{team}}.",

    "phase_kickoff": "Avspark.",
    "kickoff_1st_half": "Avspark första halvlek.",
    "kickoff_2nd_half": "Avspark andra halvlek.",
    "kickoff_1st_overtime": "Avspark första förlängning.",
    "kickoff_2nd_overtime": "Avspark andra förlängning.",
    "start_of_penalties": "Straffläggning.",

    "phase_end": "Paus.",
    "end_1st_half": "Paus.",
    "end_2nd_half": "Paus före extra tid.",
    "end_1st_overtime": "Paus mellan extra tid.",
    "end_2nd_overtime": "Paus innan straffar.",

    "game_over": "Matchen slut.",
    "game_over_1": "Matchen slut, {{winning_team}} vinner på {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_2": "Matchen slut, oavgjort på {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_3": "Matchen slut, {{winning_team}} vinner. {{score_home}}-{{score_visiting}}",
    "game_over_4": "Matchen slut, oavgjort. {{score_home}}-{{score_visiting}}",

    "shot": "Skott",
    "blocked_shot": "Blockerat skott",
    "shot_on_goal": "Skott på mål",
    "shot_wide": "Skott utanför mål",
    "shot_on_bar": "Ribbskott",
    "shot_on_post": "Stolpskott",

    "blocked_shot_team": "Skott för {{team}}. Skottet blockerat.",
    "blocked_shot_team_player": "Skott av {{player}}, {{team}}. Skottet blockerat.",

    "heading": "Nick",
    "heading_on_goal": "Nick på mål",
    "heading_wide": "Nick utanför",
    "heading_on_bar": "Nick i ribban",
    "heading_on_post": "Nick i stolpen",

    "penalty_miss": "Straffmiss",

    "shot_by_team": "{{shot_description}} för {{team}}.",
    "shot_by_player": "{{shot_description}} av {{player}}, {{team}}.",

    "corner": "Hörnspark.",
    "corner_by_team": "Hörnspark, {{team}}.",

    "offside": "Offside.",
    "offside_by_team": "Offside, {{team}}.",
    "offside_by_player": "{{player}} offside, {{team}}.",

    "throw_in": "Inkast.",
    "throw_in_by_team": "Inkast, {{team}}.",

    "save": "Räddning.",
    "save_by_team": "Räddning, {{team}}.",

    "free_kick": "Frispark.",
    "free_kick_by_team": "Frispark, {{team}}.",

    "injury": "Skada.",

    "interesting_event": "Intressant händelse.",

    "substitution": "Byte.",
    "substitution_team": "Byte, {{team}}.",
    "substitution_player_in_out": "{{player_out}} ut, {{player_in}} in.",

    "medical_assistance": "Läkarhjälp.",
    "medical_assistance_player": "Läkarhjälp, {{player}}."
}


// WEBPACK FOOTER //
// ./src/js/include/translations/Swedish.js